import { createContext, useContext, useState } from "react";
import { Loading } from "../components/loading.js";


const LoadingConetxt = createContext(null);

const LoadingProvider = ({ children }) => {

    const [loading, setInnerLoading] = useState(false);

    const setLoading = (op) => {
        setInnerLoading(op);
        if (op === true) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
    }

    return (
        <LoadingConetxt.Provider value={
            {
                loading,
                setLoading,
            }
        }>
            {
                loading === true && (
                    <Loading />
                ) 
            }
            {children}

        </LoadingConetxt.Provider>
    );
}


const useLoading = () => {
    const context = useContext(LoadingConetxt);
    if (!context) {
        throw new Error('useLoading debe ser utilizado dentro de LoadingProvider');
    }
    return context;
};

export { LoadingProvider, useLoading };